import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InputTextModule } from 'primeng/inputtext';
import { AccordionModule } from 'primeng/accordion';
import { TabViewModule } from 'primeng/tabview';
import { KeyFilterModule } from 'primeng/keyfilter';
import { ToggleButtonModule } from 'primeng/togglebutton';
import { ToastModule } from 'primeng/toast';
import { PanelMenuModule } from 'primeng/panelmenu';
import { CarouselModule } from 'primeng/carousel';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import {DropdownModule} from 'primeng/dropdown';
import { TableModule } from 'primeng/table';
import { CheckboxModule } from 'primeng/checkbox';
import { RadioButtonModule } from 'primeng/radiobutton';
import { TooltipModule } from 'primeng/tooltip';
import { ButtonModule } from 'primeng/button';
@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    InputTextModule,
    AccordionModule,
    TabViewModule,
    KeyFilterModule,
    ToggleButtonModule,
    ToastModule,
    PanelMenuModule,
    CarouselModule,
    ScrollPanelModule,
    DropdownModule,
    TableModule,
    CheckboxModule,
    RadioButtonModule,
    TooltipModule,
    ButtonModule
  ],
  exports: [
    InputTextModule,
    AccordionModule,
    TabViewModule,
    KeyFilterModule,
    ToggleButtonModule,
    ToastModule,
    PanelMenuModule,
    CarouselModule,
    ScrollPanelModule,
    DropdownModule,
    TableModule,
    CheckboxModule,
    RadioButtonModule,
    TooltipModule,
    ButtonModule
  ]
})
export class PrimeModuleModule { }
